import { render, staticRenderFns } from "./measure-effect.vue?vue&type=template&id=152bbfd0&scoped=true&"
import script from "./measure-effect.vue?vue&type=script&lang=js&"
export * from "./measure-effect.vue?vue&type=script&lang=js&"
import style0 from "./measure-effect.vue?vue&type=style&index=0&id=152bbfd0&lang=less&scoped=true&"
import style1 from "./measure-effect.vue?vue&type=style&index=1&id=152bbfd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152bbfd0",
  null
  
)

export default component.exports